export enum PeelingRateBasedEnum{
    MEAT = "MEAT",
    KG = "KG"
}